import axios from 'axios'
import { Notification } from 'element-ui'
import router from '@/router'
// import store from '../store'
import qs from 'qs'
axios.defaults.baseURL =  SERVER_PATH

const httpInstance = axios.create({
	responseType: 'json',
	timeout: 50000,
	params: {},
	data: {},
	validateStatus(status) {
		return status >= 200 && status < 300
	},
})

function responseErrorHandler(error) {
	// store.commit('updateLoadingStatus', {
	// 	isLoading: false
	// })
	let text = '未知错误'
	const response = JSON.parse(JSON.stringify(error))
	if (response.status) {
		const {code, msg} = response.data
		text = msg
		if (code === 40008) {
			router.push({
				name: '/index'
			})
		}
	} else {
		text = '请求超时'
		
		
	}

	Notification({
		type: 'error',
		title: '请求错误',
		message: text,
		duration: 5000,
	})
}

httpInstance.interceptors.request.use((config) => {
	config.url = axios.defaults.baseURL + config.url
	const configs = config
	const token = localStorage.getItem('wallet_token')
	if (token) {
		config.headers.token = token
		//text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9
		// if (configs.method == "post") {
		// 	configs.data.token = token
		// } else {
		// 	configs.params.token = token
		// }
	}
	// console.log(config)
	if(!((config.params&&config.params.noHeader)||(config.data&&config.data.noHeader))){
		config.headers['LANG'] = 'cn'
		config.headers['WL_NO'] = 'AlphaPay' 
		config.headers['REQUEST_URL'] =configs.url.indexOf('/')>0?'/'+configs.url:configs.url 
	}
	
	// store.commit('updateLoadingStatus', {
	// 	isLoading: true
	// })
	if (config.method === 'post') {
		const obj = {}
		Object.entries(config.data).forEach(([key, value]) => {
			if (value || value === '0' || value === 0 || value == 'empty') {
				obj[key] = value == 'empty' ? '' : value
			}
		})
		config.data = obj
		if(config.postDataType !== 'Bean'){
			configs.data = qs.stringify(config.data)
		}
		
	}
	return configs
}, error => Promise.reject(error))

httpInstance.interceptors.response.use((response) => {
	const {status, data} = response
	const {code, msg} = data
	// store.commit('updateLoadingStatus', {
	// 	isLoading: false
	// })
	if (status === 200) {
		if (code == 200) {
			return data
		}
		responseErrorHandler(response)
	}
	return Promise.reject(response)
}, (error) => {
	responseErrorHandler(error)
	return Promise.reject(error)
})

export const $http = {
	get:(url, params = {}, config = {}) => {
		const normalizedParams = params
		return httpInstance.get(url, {
			params: normalizedParams,
			...config,
		})
	},
	post: (url, data = null, config = {}) => httpInstance.post(url, data, config),
	postBean: (url, data = null, config = {}) => httpInstance.post(url, data, {postDataType:'Bean',...config}),
	put: (url, params = null, config = {}) => httpInstance({
		method: 'PUT',
		url,
		params,
		...config
	}),
	delete: (url, params = null, config = {}) => httpInstance({
		method: 'DELETE',
		url,
		params,
		...config
	})
}

export default {
	install(Vue) {
		Object.defineProperty(Vue.prototype, '$http', {
			value: $http,
			writable: false,
		})
	},
}
